import React from 'react'
import {  Outlet } from 'react-router-dom'
import InfoCounterSettingMenu from './settingMenu'


const InfoCounterSettings = () => {

  return (
    <>
    <section className='dash-main'>
    <InfoCounterSettingMenu/>
    <div className="dash-main-R" style={{minHeight:'75vh'}}>
        <div className="dash-side-R-body">
            <Outlet/>
        </div>
    </div>
    </section>
    </>
  )
}

export default InfoCounterSettings